const Sup = ({ size = 'primary', children }) => {
  const sizes = {
    primary: '-top-[9px] md:-top-[25px]',
    secondary: '-top-[9px] md:-top-[22px] text-[60%]',
  }
  return <sup className={sizes[size]}>{children}</sup>
}

export default Sup
